const routes = [
  {
    path: '',
    name: 'Lead',
    component: () => import('./pages/Escort/index.vue'),
    meta: {
      title: 'Ведение курсов',
    },
    children: [
      {
        path: 'teaching',
        name: 'Teaching',
        component: () => import('./pages/Escort/Teaching.vue'),
        meta: {
          title: 'Консультации и задания',
          breadcrumbs: {
            parent: 'Lead',
          },
        },
      },
      {
        path: 'base-knowledge',
        name: 'GptBaseKnowledge',
        component: () => import('./pages/Escort/GptBaseKnowledge.vue'),
        meta: {
          title: 'База знаний',
          breadcrumbs: {
            parent: 'Lead',
          },
        },
      },
      {
        path: 'faq',
        name: 'TeacherFaq',
        component: () => import('./pages/Escort/TeacherFaq.vue'),
        meta: {
          title: 'Типовые вопросы',
          breadcrumbs: {
            parent: 'Lead',
          },
        },
      },
      {
        path: 'telegram-notifications',
        name: 'Notifications',
        component: () => import('./pages/Escort/Notifications.vue'),
        meta: {
          title: 'Настройка уведомлений',
          breadcrumbs: {
            parent: 'Teaching',
          },
        },
      },
      {
        path: 'supervision',
        name: 'Supervision',
        component: () => import('./pages/Supervision.vue'),
        meta: {
          title: 'Курирование',
          breadcrumbs: {
            parent: 'Lead',
          },
        },
      },
      {
        path: 'analytic',
        name: 'EducationCoursesAnalytic',
        component: () => import('./pages/Escort/CourseAnalytic.vue'),
        meta: {
          title: 'Статистика курсов',
          authorize: [],
          breadcrumbs: {
            parent: 'Lead',
          },
        },
      },
      {
        name: 'EducationCoursesTelegramChannels',
        path: 'telegram-channels',
        component: () => import('./pages/Escort/TelegramChannels.vue'),
        meta: {
          title: 'Телеграм каналы',
          authorize: [],
          breadcrumbs: {
            parent: 'Lead',
          },
        },
      },
    ],
  },
  {
    path: '/student-review/:id',
    name: 'StudentReview',
    component: () => import('./pages/StudentReview.vue'),
    meta: {
      title: 'Обучающийся',
      authorize: [],
    },
  },
  {
    path: '/details/:id',
    name: 'ConsultationTasksDetail',
    component: () => import('./pages/ConsultationTasksDetail.vue'),
    meta: {
      authorize: [],
    },
  },
];

export default routes;
